import React from 'react';
import styled from 'styled-components';

import WheelPointer from '../../../asset/mama/wheel-pointer.png';
import WheelImg from '../../../asset/mama/wheel.png';

export const WheelAction: React.FC<{
  spinValue?: number;
  startSpinning?: boolean;
}> = ({ spinValue = 0, startSpinning = false }) => {
  const [isSpinning, setIsSpinning] = React.useState(startSpinning);

  const sectorAngle = 360 / 6; // 60
  const fullSpins = 10 * 360; // 3600

  const rotationDegrees = isSpinning
    ? fullSpins + Number(spinValue) * sectorAngle
    : 0;

  React.useEffect(() => {
    if (startSpinning) {
      setIsSpinning(true);
    }
  }, [startSpinning]);

  return (
    <Container>
      <Pointer src={WheelPointer} alt="pointer" />
      <WheelImage src={WheelImg} alt="Wheel" rotation={rotationDegrees} />
    </Container>
  );
};

const WheelImage = styled.img<{ rotation: number }>`
  min-width: 544px;
  height: auto;
  transform: rotate(0deg);
  transition: transform 10s cubic-bezier(0.1, 0.9, 0.2, 1);

  @media screen and (max-width: 927px) {
    min-width: 435px;
  }

  @media screen and (max-width: 794px) {
    min-width: 345px;
    width: 345px;
  }

  @media screen and (max-width: 426px) {
    min-width: 295px;
    width: 295px;
  }

  ${({ rotation }) => rotation > 0 && `transform: rotate(-${rotation}deg);`}
`;

const Pointer = styled.img`
  position: absolute;
  z-index: 1;
  width: 99px;
  height: auto;
  right: 0px;
  top: 100px;

  @media screen and (max-width: 927px) {
    width: 90px;
    right: 10px;
    /* top: 30px; */
  }

  @media screen and (max-width: 794px) {
    width: 75px;
    top: 60px;
     /* right: 40px; */
  }

  @media screen and (max-width: 665px) {
    /* right: 40px; */
    top: 60px;
  }

  @media screen and (max-width: 426px) {
    width: 59px;
    /* right: 40px; */
    top: 60px;
  }
`;

const Container = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  padding: 0 0 0 22px;

  @media screen and (max-width: 665px) {
    width: max-content;
    padding: unset;
  }
`;
